const hasPersonalDetails = (label, personalDetails) => {
  if (!personalDetails) {
    return false;
  }
  const matches = label.match(/\{([^}]+)\}/g);
  if (!matches) {
    return true;
  }
  const parameters = matches.map((match) => {
    const property = match.replace(/[{}]/g, "");
    if (personalDetails[property]) {
      return true;
    }
    return false;
  });
  return parameters.every((parameter) => parameter);
};
const getPersonalizedGreeting = ({ getLabel, getFormattedLabel, personalDetails }) => {
  const augmentedPersonalDetails = {
    ...personalDetails,
    /**
     * We see a lot of OpCos use the first letter of the first name to
     * create a greeting like "Hello Mr. J. Smith". This data point is usually
     * not in the personal details data we gather via the personal details
     * form, so we create it here on the fly. This allows the OpCo to use
     * this data point in their label.
     */
    ...personalDetails?.firstName ? { firstLetter: personalDetails?.firstName.substring(0, 1) } : {}
  };
  const message = hasPersonalDetails(
    getLabel("account.menu.greeting.withPersonalDetails"),
    augmentedPersonalDetails
  ) ? getFormattedLabel("account.menu.greeting.withPersonalDetails", {
    labelData: augmentedPersonalDetails
  }) : getLabel("account.menu.greeting.withoutPersonalDetails");
  return message;
};
export {
  getPersonalizedGreeting
};
//# sourceMappingURL=get-personalized-greeting.js.map
